import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { Files } from "./files";
import { MaterialInfo } from "./info";
import { usePurchasesDetailModel } from "./purchasesDetailModel";
import { IPurchaseTabEnum } from "../../purchasesTypes";
import { AuditDetail } from "./audit";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = usePurchasesDetailModel(({ tabActive }) => [tabActive]);

    const RenderTabItem = () => {
        switch (tabActive) {
            case IPurchaseTabEnum.MATERIAL_INFO:
                return <MaterialInfo {...detailsInfo} />;
            case IPurchaseTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case IPurchaseTabEnum.AUDIT_DETAIL:
                return <AuditDetail {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IPurchaseTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }

    const action = <>
        <Button
            className={classname(IPurchaseTabEnum.MATERIAL_INFO)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IPurchaseTabEnum.MATERIAL_INFO)}
        >商品信息</Button>
        {detailsInfo.mode === "edit" && <>
            <Button
                className={classname(IPurchaseTabEnum.FILES)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IPurchaseTabEnum.FILES)}
            >附件管理</Button>
            <Button
                className={classname(IPurchaseTabEnum.AUDIT_DETAIL)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IPurchaseTabEnum.AUDIT_DETAIL)}
            >审批明细</Button>
        </>}
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <RenderTabItem />
        </>
    )
}